module.exports = __webpack_public_path__ + "static/media/onboarding1.a4eb8f27.png";